import { faRadar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Theme } from 'helpers/theme';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { getStatusInfo } from '../../utils/helpers';
import { SimulatorApp_imageResult$data } from './__generated__/SimulatorApp_imageResult.graphql';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: 280,
    borderRadius: 20
  },
  mainButton: {
    color: 'white',
    cursor: 'pointer',
    width: '100%',
    border: '4px solid #03030361',
    display: 'flex',
    padding: 15,
    alignItems: 'center',
    fontWeight: 600,
    borderRadius: 14,
    justifyContent: 'center',
    fontFamily: 'Clash Display',
    gap: '12px',
    fontSize: 18
  },
  clearButton: {
    extend: 'mainButton',
    background: '#1D752B',
    '&:hover': {
      background: '#2E8C3A'
    }
  },
  reportButton: {
    extend: 'mainButton',
    background: '#8A3529',
    '&:hover': {
      background: '#ab4132'
    }
  },
  nilState: {
    color: '#969696',
    display: 'flex',
    padding: 28,
    fontSize: 13,
    background: '#8c8c8c17',
    marginTop: 17,
    textAlign: 'center',
    alignItems: 'center',
    fontWeight: 300,
    borderRadius: 12,
    justifyContent: 'center'
  },
  override: {
    color: '#969696',
    display: 'flex',
    padding: 15,
    fontSize: 13,
    background: '#1e1e21',
    border: '1px solid #343436',
    textAlign: 'center',
    alignItems: 'center',
    borderRadius: 12,
    justifyContent: 'center',
    flexDirection: 'column'
  },
  suspectText: {
    color: 'white',
    fontSize: 13,
    fontWeight: 600,
    marginTop: 20
  },
  suspectRow: {
    display: 'flex',
    marginTop: 10
  },
  suspectDropdown: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    color: 'white',
    border: '1px solid #2E2E2E',
    padding: '10px 17px',
    background: '#222222',
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 700,
    position: 'relative',
    cursor: 'pointer',
    '&:hover': {
      background: '#2E2E2E'
    }
  },
  suspectDelete: {
    color: '#969696',
    padding: '10px 12px',
    border: '1px solid #2E2E2E',
    background: '#222222',
    borderRadius: 10,
    marginLeft: 10,
    cursor: 'pointer',
    '&:hover': {
      background: '#2E2E2E'
    }
  },
  droppedBox: {
    border: '1px solid #2E2E2E',
    padding: '2px',
    background: '#222222',
    borderRadius: 10,
    position: 'absolute',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    bottom: 0,
    right: 'calc(100% + 10px)'
  },
  droppedBoxOption: {
    padding: 10,
    borderRadius: 8,
    color: 'white',
    '&:hover': {
      background: '#67676724'
    },
    cursor: 'pointer'
  },
  endSession: {
    extend: 'mainButton',
    background: '#8731bc',
    '&:hover': {
      background: '#a73be9'
    }
  },
  showThreat: {
    color: 'white',
    width: '100%',
    border: '1px solid #3E3D3D',
    padding: 9,
    background: '#313131',
    borderRadius: 7,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '11px',
    cursor: 'pointer',
    marginBottom: 10,
    '&:hover': {
      background: '#3b3a3a'
    }
  },
  resultInfo: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    padding: 10
  },
  categoryRow: {
    display: 'flex',
    marginTop: 10
  },
  catLabel: {
    color: '#969696',
    fontSize: 14,
    fontWeight: 600
  }
}));

type Props = {
  onToggleThreat: () => void;
  imageResult?: SimulatorApp_imageResult$data;
  showThreat: boolean;
  identRef: React.RefObject<HTMLDivElement>;
};

export default function IdentifyBox({
  onToggleThreat,
  imageResult,
  identRef,
  showThreat
}: Props) {
  const classes = useStyles();

  const { threatIcon, threatText } = getStatusInfo(
    imageResult?.identifiedStatus
  );
  return (
    <div className={classes.container} ref={identRef}>
      {imageResult && (
        <div className={classes.override}>
          {imageResult.image.threat && (
            <div className={classes.showThreat} onClick={onToggleThreat}>
              <FontAwesomeIcon icon={faRadar} />
              {showThreat ? 'Hide' : 'Show'} threat
            </div>
          )}

          <div className={classes.resultInfo}>
            {threatIcon}
            {threatText}
          </div>
        </div>
      )}
    </div>
  );
}
